'use strict';

/* Component
 * 모든 컴포넌트들은 해당 컴포넌트를 상속받아야 함
 * mount(event) : 마운트를 통해서 렌더 후 실행할 이벤트 및 event를 통해 다른 컴포넌트로 이벤트를 넘길 수 있음.
 * render() : 페이지에 렌더를 진행하는 함수 */
class Component {
    constructor() {

    }

    mount(event) {

    }

    render() {

    }
}

export default Component;



//////////////////
// WEBPACK FOOTER
// ./js/lib/Component.js
// module id = 1
// module chunks = 0